import { render, staticRenderFns } from "./SelectFormSponsors.vue?vue&type=template&id=1c6bcc4b"
import script from "./SelectFormSponsors.vue?vue&type=script&lang=js"
export * from "./SelectFormSponsors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports